import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import { useAITutorStack } from '../../../pages/[lang]/webview/ai-tutor'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'

const AITutorPurchaseCompleteBody = dynamic(
  () => import('../../new-portal/ai-tutor-pricing/AITutorPurchaseCompleteWebView'),
  {
    loading: () => (
      <div className="flex h-screen w-screen items-center justify-center">
        <LoadingSpinner lg show primary />
      </div>
    ),
  }
)

const AITutorPurchaseCompleteActivity: ActivityComponentType = () => {
  const { useAITutorFlow } = useAITutorStack()
  const { push, pop } = useAITutorFlow()
  return (
    <WebviewStackContainer height="0px" border={false} onBack={pop}>
      <div className="relative overflow-hidden">
        <AITutorPurchaseCompleteBody />
      </div>
    </WebviewStackContainer>
  )
}

export default AITutorPurchaseCompleteActivity
